module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-68fd232c6c386801bab38341fb744751.svg";